// Redux-related typedefs probably make more sense to be in the reducer/action files where they are used,
// but converting those files to TypeScript causes many type errors across the codebase due to tech debt,
// so they are defined here until those can be resolved.

export enum LoginModalPreviousAction {
  REFINE_RECOMMENDATIONS = "refine_recommendations",
  SUBMIT_FEATURE_REQUEST = "submit_feature_request",
  ADD_TO_NETWORK = "add_to_network",
}
